import "./App.css";
import BudgetAllocator from "./components/BudgetAllocator";

function App() {
  return (
    <div className="App">
      <BudgetAllocator />
    </div>
  );
}

export default App;